import { createGlobalStyle } from 'styled-components';

import BebasNeue from '../fonts/BebasNeue-Regular.ttf';
import InterVariable from '../fonts/Inter-VariableFont_opsz,wght.ttf';
import PublicSans from '../fonts/PublicSans-VariableFont_wght.ttf';
import Fineday from '../fonts/Fineday-StyleOne.ttf';

const GlobalFonts = createGlobalStyle`
  @font-face {
    font-family: 'TitleFont';
    src: url(${BebasNeue}) format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'HeadingFont';
    src: url(${InterVariable}) format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'BodyFont';
    src: url(${PublicSans}) format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'CreativeFont';
    src: url(${Fineday}) format('truetype');
    font-display: swap;
  }

  /* OCR-B for human-readable text under UPC/EAN barcodes.
     Place the font file at public/fonts/OCRB.ttf or adjust the URL below. */
  @font-face {
    font-family: 'OCRB';
    src: local('OCRB'),
         url('/fonts/OCRB.woff2') format('woff2'),
         url('/fonts/OCRB.woff') format('woff'),
         url('/fonts/OCRB.ttf') format('truetype');
    font-display: swap;
    font-weight: 400;
    font-style: normal;
  }

  :root {
    --font-title: 'TitleFont', sans-serif;
    --font-heading: 'HeadingFont', sans-serif;
    --font-body: 'BodyFont', sans-serif;
    --font-creative: 'CreativeFont', cursive;
    --font-ocrb: 'OCRB', monospace;
  }

  body {
    font-family: var(--font-body);
    font-size: 16px;
    line-height: 1.5;
    color: var(--color-text);
    margin: 0;
    padding: 0;
    background-color: transparent;
  }

  h1 {
    font-family: var(--font-title);
    font-weight: 500;
    font-size: 2rem;
    margin-bottom: -0.5rem;
    color: var(--color-text);
  }

  h2, h3, h4, h5, h6 {
    font-family: var(--font-heading);
    font-weight: 500;
    color: var(--color-text);
  }

  p, label, span, input, textarea, select, button {
    font-family: var(--font-body);
    font-size: 0.95rem;
  }

  table {
    font-family: var(--font-body);
    font-size: 0.85rem;
  }

  th {
    font-family: var(--font-heading);
    font-weight: 600;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  td {
    font-family: var(--font-body);
    font-size: 0.85rem;
  }

  button {
    font-weight: 500;
    cursor: pointer;
  }

  code {
    font-family: monospace;
  }

  @media (max-width: 768px) {
    body {
      font-size: 15px;
    }

    h1 {
      font-size: 1.75rem;
    }

    p, label, span, input, textarea, select, button {
      font-size: 0.9rem;
    }

    table, td {
      font-size: 0.8rem;
    }

    th {
      font-size: 0.75rem;
    }
  }
`;

export default GlobalFonts;